<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'admin-template'}">{{ $t('templateDashboard.cards.templateManagement') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'registry-permission'}">{{ $t('templateDashboard.cards.registryPermission') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "TemplateDashboardPage",
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('templateDashboard.pageTitle'))
  }
}
</script>

<style scoped>

</style>